import axios from 'axios';

import { EventBus } from '@/plugins/event-bus';

const IGNORE_ID = 'ignoreId';

const resourceIdMissing = (id) => !id && id !== IGNORE_ID;

const requestConfig = (id, params = {}, selfWithCredentials = false) => {
  const config = { params };
  if (id === IGNORE_ID && selfWithCredentials) config.withCredentials = true;
  return config;
};

export const handleError = (error) => {
  // if (process.env.NODE_ENV === 'test') throw error;
  EventBus.$emit('error', error);
};

export const asyncApi = ({
  endpoint,
  payloadKey,
  pathSuffix = '',
  selfWithCredentials = false,
}) => {
  const buildRequestConfig = (id, params = {}) => requestConfig(id, params, selfWithCredentials);

  return {
    endpoint,
    payloadKey,
    pathSuffix,

    baseUrl(id = null) {
      let url = `${window.api_url}${this.endpoint}`;
      if (id && id !== IGNORE_ID) url += `/${id}`;
      if (this.pathSuffix) url += this.pathSuffix;
      return url;
    },

    createPayload(value) {
      if (!this.payloadKey) return { data: value };

      return { [this.payloadKey]: value };
    },

    async get(id, params = {}, successCallback = null, failureCallback = null) {
      if (resourceIdMissing(id)) return handleError(new Error('ID is required'));

      return axios
        .get(this.baseUrl(id), buildRequestConfig(id, params))
        .then((response) => {
          if (successCallback) successCallback(response);
          return response;
        })
        .catch((error) => {
          if (failureCallback) return failureCallback(error);
          return handleError(error);
        });
    },

    async create(createObject, successCallback = null, failureCallback = null) {
      return axios
        .post(this.baseUrl(), this.createPayload(createObject))
        .then((response) => {
          if (successCallback) successCallback(response);
          return response;
        })
        .catch((error) => {
          if (failureCallback) return failureCallback(error);
          return handleError(error);
        });
    },

    async index(params = {}, successCallback = null, failureCallback = null) {
      return axios
        .get(this.baseUrl(), { params })
        .then((response) => {
          if (successCallback) successCallback(response);
          return response;
        })
        .catch((error) => {
          if (failureCallback) return failureCallback(error);
          return handleError(error);
        });
    },

    async update(id, updateObject, params = {}, successCallback = null, failureCallback = null) {
      if (resourceIdMissing(id)) return handleError(new Error('ID is required'));

      return axios
        .patch(this.baseUrl(id), this.createPayload(updateObject), buildRequestConfig(id, params))
        .then((response) => {
          if (successCallback) successCallback(response);
          return response;
        })
        .catch((error) => {
          if (failureCallback) return failureCallback(error);
          return handleError(error);
        });
    },

    async destroy(id, successCallback = null, failureCallback = null) {
      if (resourceIdMissing(id)) return handleError(new Error('ID is required'));

      return axios
        .delete(this.baseUrl(id))
        .then((response) => {
          if (successCallback) successCallback(response);
          return response;
        })
        .catch((error) => {
          if (failureCallback) return failureCallback(error);
          return handleError(error);
        });
    },

    getSelf({ params = {}, successCallback = null, failureCallback = null } = {}) {
      return this.get(IGNORE_ID, params, successCallback, failureCallback);
    },

    updateSelf({ body, params = {}, successCallback = null, failureCallback = null }) {
      return this.update(IGNORE_ID, body, params, successCallback, failureCallback);
    },
  };
};
